import React from 'react';
import { Search } from '@insurancemenu/imenu-components-lib/dist/icons';
import { NoPlansSectionStyled, NoPlansSectionTitleStyled, NoPlansBrowseButtonStyled } from './styles';

interface NoPlansSectionProps {
  onBrowseClick: () => void;
}

const NoPlansSection: React.FC<NoPlansSectionProps> = ({ onBrowseClick }) => {
  return (
    <NoPlansSectionStyled>
      <NoPlansSectionTitleStyled>
        There are no popular products for this product line.
        <br />
        Select browse all plans below.
      </NoPlansSectionTitleStyled>
      <NoPlansBrowseButtonStyled
        leftIconProp={<Search />}
        size="large"
        type="contained"
        color="primary"
        onClick={onBrowseClick}
      >
        Browse all plans
      </NoPlansBrowseButtonStyled>
    </NoPlansSectionStyled>
  );
};

export default NoPlansSection;
